import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import MultiSelect from '@components/form/MultiSelect';
import usePasswordValidation from 'lib/src/hooks/usePasswordValidation';

import Modal from '@components/modal/Modal';
import useCreateAdmin from './hooks/useCreateAdmin';

import Select from '@components/form/Select';
import { userRoleValues } from '../../../types/shared/User';
import { userRoles } from 'lib/src/shared/enums/dropdownEnums';
const { superAdmin, admin, user } = userRoles;
const invalidCreateRoles = [superAdmin, admin, user];
const adminRoleOptions = Object.entries(userRoleValues)
    .filter(([key]) => !invalidCreateRoles.includes(+key))
    .map(([key, value]) => ({
        value: +key,
        label: value,
    }));
const CreateAdminUserModal: React.FC = () => {
    const {
        isPosting,
        handleChange,
        handleSubmit,
        closeModal,
        formState: { email, firstName, lastName, password, confirmPassword, roles, site },
        siteOptions,
        shouldShowSiteOptions,
    } = useCreateAdmin();
    const { validatePassword, validateConfirmPassword } = usePasswordValidation(password);

    return (
        <Modal closeModal={closeModal} title="Create Admin">
            <div className="modal-scroll-content">
                <Form onSubmit={handleSubmit} isPosting={isPosting} onCancel={closeModal}>
                    <FormRow>
                        <TextInput
                            type="email"
                            name="email"
                            value={email}
                            onChange={handleChange}
                            label="Email address"
                            required
                        />
                    </FormRow>
                    <FormRow>
                        <TextInput
                            name="firstName"
                            value={firstName}
                            onChange={handleChange}
                            label="First name"
                            required
                        />
                    </FormRow>
                    <FormRow>
                        <TextInput
                            name="lastName"
                            value={lastName}
                            onChange={handleChange}
                            label="Last Name"
                            required
                        />
                    </FormRow>
                    <FormRow>
                        <TextInput
                            name="password"
                            value={password}
                            onChange={handleChange}
                            label="Password"
                            type="password"
                            required
                            customValidate={validatePassword}
                        />
                    </FormRow>
                    <FormRow>
                        <TextInput
                            name="confirmPassword"
                            value={confirmPassword}
                            onChange={handleChange}
                            label="Confirm Password"
                            type="password"
                            customValidate={validateConfirmPassword}
                            required
                        />
                    </FormRow>
                    <FormRow>
                        <MultiSelect
                            name="roles"
                            value={roles}
                            options={adminRoleOptions}
                            onChange={handleChange}
                            label="Admin roles"
                            required
                        />
                    </FormRow>
                    {shouldShowSiteOptions && (
                        <FormRow>
                            <Select
                                name="site"
                                value={site}
                                options={siteOptions}
                                onChange={handleChange}
                                label="Site"
                                required
                            />
                        </FormRow>
                    )}
                </Form>
            </div>
        </Modal>
    );
};

export default CreateAdminUserModal;
